// client/src/components/license/LicenseStatusChip.js
import React from "react";
import { Chip, Tooltip } from "@mui/material";
import {
  CheckCircle,
  Error,
  Warning,
  Info,
  Block,
  Schedule,
} from "@mui/icons-material";
import {
  calculateLicenseStatus,
  getLicenseStatusDisplay,
  getDaysUntilExpiry,
} from "../../utils/licenseStatusUtils";

const iconMap = {
  CheckCircle,
  Error,
  Warning,
  Info,
  Block,
  Schedule,
};

const LicenseStatusChip = ({ license, size = "small", showTooltip = true }) => {
  const status = calculateLicenseStatus(license);
  const statusDisplay = getLicenseStatusDisplay(status);
  const daysUntilExpiry = getDaysUntilExpiry(license);
  
  // Customize label for expiring soon status to show exact days
  let customLabel = statusDisplay.label;
  if (status === 'expiring_soon' && daysUntilExpiry !== null) {
    if (daysUntilExpiry === 0) {
      customLabel = 'Expires Today';
    } else if (daysUntilExpiry === 1) {
      customLabel = 'Expires Tomorrow';
    } else if (daysUntilExpiry > 1) {
      customLabel = `${daysUntilExpiry} Days Left`;
    }
  }
  
  const IconComponent = iconMap[statusDisplay.icon];
  
  let tooltipText = statusDisplay.description;
  if (daysUntilExpiry !== null) {
    if (daysUntilExpiry > 0) {
      tooltipText += ` (${daysUntilExpiry} day${daysUntilExpiry === 1 ? '' : 's'} remaining)`;
    } else if (daysUntilExpiry === 0) {
      tooltipText += " (expires today)";
    } else {
      const daysAgo = Math.abs(daysUntilExpiry);
      tooltipText += ` (expired ${daysAgo} day${daysAgo === 1 ? '' : 's'} ago)`;
    }
  }

  const chip = (
    <Chip
      icon={<IconComponent />}
      label={customLabel}
      color={statusDisplay.color}
      size={size}
      variant="outlined"
    />
  );

  if (!showTooltip) {
    return chip;
  }

  return (
    <Tooltip title={tooltipText} placement="top">
      {chip}
    </Tooltip>
  );
};

export default LicenseStatusChip;
